import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";
import { FaFilePdf } from "react-icons/fa";

const ModuleSubtopicCacheManagement = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Cache Management"
    videos={[
      "https://www.youtube.com/embed/beqOrVgxsA0", // Direct Mapping, Associative Mapping, Set Associative Mapping
      "https://www.youtube.com/embed/V_QS1HzJ8Bc", // Direct Memory Mapping
      "https://www.youtube.com/embed/uwnsMaH-iV0", // Associative Mapping
      "https://www.youtube.com/embed/KhAh6thw_TI", // Set Associative Mapping
      "https://www.youtube.com/embed/w32d1lD0Jb0", // LRU Replacement Algorithm
      "https://www.youtube.com/embed/e8ZrvrNdp9o", // FIFO Replacement Policy
      "https://www.youtube.com/embed/q2BpMvPhhrY", // Optimal Page Replacement
    ]}
    takeaways={[
      {
        text: (
          <span>
            Refer to this PDF for Write Policies (this will be more than enough and questions will be similar):&nbsp;
            <a
              href="https://drive.google.com/file/d/1yY6XjUza7cQUWUknUCGnpGL-lTVexPi6/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                color: "#0f4c75",
                textDecoration: "none",
              }}
            >
              <FaFilePdf style={{ marginRight: "6px" }} />
              View PDF 1
            </a>
            &nbsp;|&nbsp;
            <a
              href="https://drive.google.com/file/d/1Y5W6W5zaONv3qki9FCiZEyaQGQ0Dr4JT/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                color: "#0f4c75",
                textDecoration: "none",
              }}
            >
              <FaFilePdf style={{ marginRight: "6px" }} />
              View PDF 2
            </a>
          </span>
        ),

      },
      { text: "This topic is large but easy (Tip: Have a friend explain it to you, and it can be completed in less than 1 hour)." },
      { text: "Questions from this topic will be straightforward and easy." },
      { text: "Don’t leave any subtopic from Cache Management (questions can come from any part)." },
      { image: "/CAOm5cache.png",}
    ]}
    questions={[
      "Explain Direct, Associative, and Set Associative Mapping.",
      "What are the different Cache Replacement Policies?",
      "Describe LRU, FIFO, and Optimal Page Replacement Algorithms.",
      "What are the Write Policies in cache memory?",
    ]}
    exampleVideos={[]} // No specific example question videos
  />
);
}

export { ModuleSubtopicCacheManagement };
